import { ACTIONS } from "../actions/GalleryActions"

const INITIAL_STATE = {
  user: {},
  products: [],
  config: {},
  userActions: {},
  showLogin: false,
  currentPage: 1,
  lastPage: 1,
  activeLoading: false,
  noItems: false,
  tokenReady: null,
  addOnFabrics: window.addOnFabrics ?? [],
  priceTable: window.priceTable ?? {},
  postLoginRedirect: null
};

const Gallery = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.SET_USER_DATA:
      return {
        ...state,
        user: action.data,
      };
    case ACTIONS.SET_SHIRTS:
      return {
        ...state,
        products: state.currentPage === 1 ? action.data.getValues() : [...state.products, ...action.data.getValues()],
        lastPage: action.data.last_page,
        noItems: action.data.getValues().length ? false : true
      };
    case ACTIONS.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.data,
      };
    case ACTIONS.SET_LOADING:
      return {
        ...state,
        activeLoading: action.data,
      };
    case ACTIONS.SET_BOOTSTRAP_DATA:
      return {
        ...state,
        config: action.data,
      };
    case ACTIONS.SET_USER_INTERACTIONS:
      return {
        ...state,
        userActions: action.data
      };
    case ACTIONS.SET_SHOW_LOGIN:
      return {
        ...state,
        showLogin: action.data,
      };
    case ACTIONS.SET_TOKEN_READY:
      return {
        ...state,
        tokenReady: action.data,
      };
    case ACTIONS.SET_POST_LOGIN_REDIRECT:
      return {
        ...state,
        postLoginRedirect: action.data,
      };
    default:
      return state;
  }
};

export default Gallery;